import * as Yup from 'yup';

export const DriverPerformanceSearchSchema = Yup.object().shape({
    ninNumber: Yup.string().min(1, 'NIN number is required').required('NIN number is required'),
});

export type DriverPerformanceSearchDataType = Yup.InferType<typeof DriverPerformanceSearchSchema>;

type InitialValues = {
    ninNumber: string;
};

export const DriverPerformanceSearchInitialValues: InitialValues = {
    ninNumber: '',
};

export interface DriverPerformanceSearchInterface {
    ninNumber: string;
}
